export const AssignmentsListingMutations = {
  SetAssignmentsLoading: 'AssignmentsListingMutations.SetAssignmentsLoading',
  SetAssignmentsList: 'AssignmentsListingMutations.SetAssignmentsList',
  SetAssignmentsFilters: 'AssignmentsListingMutations.SetAssignmentsFilters',
  SetAssignmentsSortOrder: 'AssignmentsListingMutations.SetAssignmentsSortOrder',
  SetAssignmentsPaginationParameters:
    'AssignmentsListingMutations.SetAssignmentsPaginationParameters',
  ResetAssignmentsPaginationOffset: 'AssignmentsListingMutations.ResetAssignmentsPaginationOffset',
  SetAssignmentsFilteredRecordCount:
    'AssignmentsListingMutations.SetAssignmentsFilteredRecordCount',
  UpdateSelectedAssignments: 'AssignmentsListingMutations.UpdateSelectedAssignments',
  SetAssignmentsBulkAction: 'AssignmentsListingMutations.SetAssignmentsBulkAction',
  SetModifiedAssignments: 'AssignmentsListingMutations.SetModifiedAssignments',
  SetAssignmentsSearchParam: 'AssignmentsListingMutations.SetAssignmentsSearchParam',
  SetDashboardSummary: 'AssignmentsListingMutations.SetDashboardSummary',
  SetDashboardLoading: 'AssignmentsListingMutations.SetDashboardLoading',
  SetExecutiveDashboardSummary: 'AssignmentsListingMutations.SetExecutiveDashboardSummary',
  SetExecutiveDashboardLoading: 'AssignmentsListingMutations.SetExecutiveDashboardLoading'
};

export const AssignmentsListingActions = {
  RetrieveAssignments: 'AssignmentsListingActions.RetrieveAssignments',
  SetAssignmentsFilters: 'AssignmentsListingActions.SetAssignmentsFilters',
  SetAssignmentsSortOrder: 'AssignmentsListingActions.SetAssignmentsSortOrder',
  SelectAssignment: 'AssignmentsListingActions.SelectAssignment',
  SelectDeselectAllAssignments: 'AssignmentsListingActions.SelectDeselectAllAssignments',
  SetAssignmentsPaginationParameters:
    'AssignmentsListingActions.SetAssignmentsPaginationParameters',
  RetrieveAssignmentsFilteredRecordCount:
    'AssignmentsListingActions.RetrieveAssignmentsFilteredRecordCount',
  SetAssignmentsBulkAction: 'AssignmentsListingActions.SetAssignmentsBulkAction',
  DoAssignmentsBulkAction: 'AssignmentsListingActions.DoAssignmentsBulkAction',
  ExportAssignmentsAsExcel: 'AssignmentsListingActions.ExportAssignmentsAsExcel',
  UpdateAssignmentsList: 'AssignmentsListingActions.UpdateAssignmentsList',
  SetAssignmentsLoading: 'AssignmentsListingActions.SetAssignmentsLoading',
  RetrieveDashboardSummary: 'AssignmentsListingActions.RetrieveDashboardSummary',
  RetrieveExecutiveDashboardSummary: 'AssignmentsListingActions.RetrieveExecutiveDashboardSummary'
};

export const AssignmentsListingGetters = {
  AssignmentsList: 'AssignmentsListingGetters.AssignmentsList',
  AssignmentsFilters: 'AssignmentsListingGetters.AssignmentsFilters',
  ModifiedAssignments: 'AssignmentsListingGetters.ModifiedAssignments',
  SortBy: 'AssignmentsListingGetters.SortBy',
  SortDirection: 'AssignmentsListingGetters.SortDirection',
  SelectedAssignments: 'AssignmentsListingGetters.SelectedAssignments',
  AssignmentsPerPage: 'AssignmentsListingGetters.AssignmentsPerPage',
  AssignmentsListingOffset: 'AssignmentsListingGettersAssignmentsListingOffset',
  AssignmentsFilteredRecordCount: 'AssignmentsListingGetters.AssignmentsFilteredRecordCount',
  AssignmentIsLoading: 'AssignmentsListingGetters.AssignmentIsLoading',
  DashboardSummary: 'AssignmentsListingGetters.DashboardSummary',
  IsDashboardLoading: 'AssignmentsListingGetters. IsDashboardLoading',
  ExecutiveDashboardSummary: 'AssignmentsListingGetters.ExecutiveDashboardSummary',
  IsExecutiveDashboardLoading: 'AssignmentsListingGetters.IsExecutiveDashboardLoading'
};
